var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVssx96 = function SvgVssx96(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 96 96"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vssx_96_svg__a",
    x1: 22.097,
    x2: 89.903,
    y1: 7.596,
    y2: 88.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 0.0226
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 0.0363
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "#e6e6e6",
      stopOpacity: 0.0475
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#d1d1d1",
      stopOpacity: 0.0574
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    style: {
      stopColor: "#b7b7b7",
      stopOpacity: 0.0665
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#979797",
      stopOpacity: 0.075
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#707070",
      stopOpacity: 0.083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    style: {
      stopColor: "#444",
      stopOpacity: 0.0906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    style: {
      stopColor: "#121212",
      stopOpacity: 0.0976
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vssx_96_svg__a)",
    d: "M88 6H24v84h64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26 8h60v80H26z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C8C8C8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 14v32h22V14H32m20 2v28H34V16zM32 50v32h22V50H32m20 2v28H34V52zM60.444 14H58v32h22V14zM78 44H60V16h18zM58 50v32h22V50H58m20 2v28H60V52z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M24 6v84h64V6zm62 82H26V8h60z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3955A3",
    d: "m8 34 40-6v52L8 74z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m38 42-7.33 24h-5.43L18 42h5.163L27.6 58.703q.357 1.356.43 2.393h.09q.103-1.12.46-2.46L32.985 42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vssx_96_svg__b",
    x1: 67.34,
    x2: 84.46,
    y1: 19.66,
    y2: 2.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2134
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.25
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vssx_96_svg__b)",
    d: "M24 6v2h62v48h2V6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vssx_96_svg__c",
    x1: 35.433,
    x2: 36.456,
    y1: 87.54,
    y2: 77.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#7e7e7e",
      stopOpacity: 0.0341
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    style: {
      stopColor: "#717171",
      stopOpacity: 0.0694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    style: {
      stopColor: "#5d5d5d",
      stopOpacity: 0.1053
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    style: {
      stopColor: "#404040",
      stopOpacity: 0.1415
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    style: {
      stopColor: "#1b1b1b",
      stopOpacity: 0.1778
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#000",
      stopOpacity: 0.2
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vssx_96_svg__c)",
    d: "M48 88H24V76.4L48 80z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vssx_96_svg__d",
    x1: 28,
    x2: 28,
    y1: 78.375,
    y2: 29.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.1546
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.18
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vssx_96_svg__d)",
    d: "M48 28 8 34v40l40 6z"
  })));
};
export default SvgVssx96;